import { SpecialZoneType } from '@hakimo-ui/hakimo/ui-elements';
import clsx from 'clsx';
import { useMemo } from 'react';
import {
  useAlarmGroupCamera,
  useAlarmGroupStatic,
} from '../alarm-provider/AlarmGroupProvider';
import { useMediaLayout } from '../hooks/useMediaLayout';
import { CameraFeedMode } from '../types';
import { CameraMonitorView } from './CameraMonitorView';

const EMPTY_VISIBLE_ZONE_TYPES = new Set<SpecialZoneType>();

interface Props {
  globalCamMode: CameraFeedMode;
  visibleZoneTypes?: Set<SpecialZoneType>;
}

export function AlarmGroupMedia(props: Props) {
  const { globalCamMode, visibleZoneTypes = EMPTY_VISIBLE_ZONE_TYPES } = props;
  const { alarmCameraIds, tenantAdditionalCameraIds } = useAlarmGroupStatic();
  const { showCameraIds, preloadCameraIds } = useAlarmGroupCamera();
  // allCamerasIds => camera boxes which are shown in UI
  const { sectionRef, allCamerasIds, rowCount, colCount, cameraPositionsMap } =
    useMediaLayout(
      alarmCameraIds,
      tenantAdditionalCameraIds,
      globalCamMode,
      showCameraIds,
      preloadCameraIds
    );

  const [minWidth, minHeight] = useMemo(() => {
    if (
      allCamerasIds.length > 0 &&
      Object.keys(cameraPositionsMap).length > 0
    ) {
      const width =
        cameraPositionsMap[allCamerasIds[0]].width * colCount +
        (colCount + 1) * 2;
      const height =
        cameraPositionsMap[allCamerasIds[0]].height * rowCount +
        (rowCount + 1) * 2;
      return [width, height];
    } else {
      return [0, 0];
    }
  }, [allCamerasIds, cameraPositionsMap, colCount, rowCount]);

  return (
    <section
      ref={sectionRef}
      className="relative h-full w-full overflow-y-auto p-0"
      style={{ scrollbarGutter: 'stable' }}
    >
      <div className="relative" style={{ minWidth, minHeight }}>
        {Object.keys(cameraPositionsMap).length > 0 &&
          allCamerasIds.map((camId) => {
            const position = cameraPositionsMap[camId];
            return (
              <div
                key={camId}
                className={clsx(
                  'absolute rounded-md',
                  !position && 'pointer-events-none opacity-0'
                )}
                style={{
                  top: `${position?.top ?? 0}px`,
                  left: `${position?.left ?? 0}px`,
                  width: `${position?.width ?? 0}px`,
                  height: `${position?.height ?? 0}px`,
                }}
              >
                <CameraMonitorView
                  camId={camId}
                  globalCamMode={globalCamMode}
                  visibleZoneTypes={visibleZoneTypes}
                />
              </div>
            );
          })}
      </div>
    </section>
  );
}

export default AlarmGroupMedia;
